import React, { useState } from "react";
import { EditorState, ContentState, convertToRaw } from "draft-js";
import { Editor as EditorWysiwyg } from "react-draft-wysiwyg";
import draftToHtml from "draftjs-to-html";
import htmlToDraft from "html-to-draftjs";
import "react-draft-wysiwyg/dist/react-draft-wysiwyg.css";

// function uploadImageCallBack(file: any) {
// 	return new Promise((resolve, reject) => {
// 		let dataNews = new FormData();
// 		dataNews.append('name', 'image-xxx');
// 		dataNews.append('image', file);

// 		let headers = new Headers();
// 		headers.append('Accept', 'application/json');

// 		return fetch(`${process.env.REACT_APP_URL}/api/jlp/images`, {
// 			method: 'POST',
// 			headers,
// 			body: dataNews,
// 		})
// 			.then((res) => res.json())
// 			.then((result) => {
// 				if (result.status === 'error') {
// 					alert('errorr');
// 					return false;
// 				}
// 				resolve({
// 					data: {
// 						link: `${process.env.REACT_APP_URL}/images/${result.data}`,
// 					},
// 				});
// 			})
// 			.catch((err) => {
// 				// alert(err.message);
// 			});
// 	});
// }

const Editor = ({ content, onChange }: { content: string; onChange?: any }) => {
  const contentBlock = htmlToDraft(content);
  const contentState = ContentState.createFromBlockArray(
    contentBlock.contentBlocks
  );
  const editorState = EditorState.createWithContent(contentState);

  const [state, setState] = useState(editorState);

  const onEditorStateChange = (editorState: any) => {
    setState(editorState);
    onChange(draftToHtml(convertToRaw(state.getCurrentContent())));
  };

  return (
    <>
      <EditorWysiwyg
        editorState={state}
        editorStyle={{
          fontSize: 16,
          border: "1px solid #f1f1f1",
          padding: "0 16px",
        }}
        onEditorStateChange={onEditorStateChange}
        // toolbar={{
        //   fontFamily: {
        //     options: ["Roboto", "Oswald"],
        //     className: undefined,
        //     component: undefined,
        //     dropdownClassName: undefined,
        //   },
        // }}
        // toolbar={{
        // 	image: {
        // 		uploadCallback: uploadImageCallBack,
        // 		alt: { present: true, mandatory: true },
        // 		previewImage: true,
        // 	},
        // }}
      />
    </>
  );
};

export default Editor;
